module.exports = __webpack_public_path__ + "img/file.3d2857d8.png";